<span class="history-event-type">{{ key?.length ? ('EVENT_TYPE_LABEL.' + key | translate) : '' }}</span>
